module.exports = __webpack_public_path__ + "static/img/ic_back.d08023b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_back.png
// module id = hPBg
// module chunks = 1